import Kvittering from "../../components/Kvittering";
import {Link, useLocation} from "react-router-dom";
import {useEffect} from "react";
import {getDocumentTitle} from "../../utils/documentTitle";


export function PermisjonKvittering() {
  const location = useLocation()
  const barnFulltNavn = location.state?.barnFulltNavn

  useEffect(()=> {
    document.title = getDocumentTitle("permisjon-kvittering")
  })

  return (
    <Kvittering>
      <h1 className={'pkt-txt-36 mt-size-104 mb-size-24'}>Søknad om permisjon er sendt inn</h1>
      <p>
        Dette er en bekreftelse på at søknad om permisjon {barnFulltNavn ? ` for ${barnFulltNavn}` : ''} er sendt til behandling.
        Du får et brev i den digitale postkassen din (Altinn, eBoks, eller Digipost) når saken er ferdig behandlet.
      </p>
      <Link to={'/'} className={'pkt-btn mt-size-40'}>
        Gå til Din barnehageside
      </Link>
    </Kvittering>
  )
}